import React from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';


export default function PresellRow(props) {
    const history = useHistory();

    let presell = props.presell;

    let navigateToPresell = () => {
        history.push({ pathname: 'presell/' + presell.id, state: { presellName: presell.name } });
    };

    const numberToPrice = numberField => !!numberField ? '£' + numberField.toFixed(2) : '£0.00';

    const getTimeRemainingString = endTime => {
        const today = moment();
        const endDate = moment(endTime, 'YYYY-MM-DD');

        if (endDate.isBefore(today)) {
            return 'CLOSED';
        } else {
            const diffDays = endDate.diff(today, 'days');
            const diffHours = endDate.diff(today, 'hours') % 24;
            const diffMins = endDate.diff(today, 'minutes') % 60;
            const diffSecs = endDate.diff(today, 'seconds') % 60;

            let newTime = '';
            newTime += (diffDays > 0) ? diffDays + 'd ' : '';
            newTime += diffHours + 'h ';
            newTime += diffMins + 'm';
            newTime += (diffDays < 1) ? (' ' + diffSecs + 's') : '';

            return newTime;
        }
    };

    function PresellTimer() {
        const [time, setTime] = React.useState(getTimeRemainingString(props.presell.endDate));
        React.useEffect(() => {
            const intervalId = window.setInterval(() => {
                setTime(getTimeRemainingString(props.presell.endDate));
            }, 1000);
            return () => window.clearInterval(intervalId);
        });

        return time;
    }

    function determineIfPresellInOrderingRange() {
        const today = moment();
        const endDate = moment(props.presell.endDate, 'YYYY-MM-DD');
        return endDate.diff(today, 'days');
    }

    function timerType() {

        const diff = determineIfPresellInOrderingRange();

        if (diff >= 0 && diff < 2) {
            return 'col-timer-warning';
        }

        return 'col-timer';
    }

    function getCaseCount() {
        if (!!presell.orderStatus) {
            return '' + presell.caseCount;
        }

        return '';
    }

    return (
        <>
            <tr data-testid={'presell-row-' + presell.id}>
                <td className={'col-name'} data-testid={'presell-row-' + presell.id + '-name'} onClick={navigateToPresell}>
                <span className={'new-indicator-container'}>
                    {!presell.orderStatus && <span className={'new-indicator'}>New</span>}
                    {presell.name}
                </span>
                </td>
                <td className={timerType()} data-testid={'presell-row-' + presell.id + '-timer'} onClick={navigateToPresell}><PresellTimer/></td>
                <td className={'col-lines'} data-testid={'presell-row-' + presell.id + '-lines'} onClick={navigateToPresell}>{presell.numLines}</td>
                <td className={'col-deals'} data-testid={'presell-row-' + presell.id + '-deals'} onClick={navigateToPresell}>{presell.numDeals}</td>
                <td className={'col-status'} data-testid={'presell-row-' + presell.id + '-status'} onClick={navigateToPresell}>{presell.orderStatus}</td>
                <td className={'col-cases'} data-testid={'presell-row-' + presell.id + '-cases'} onClick={navigateToPresell}>{getCaseCount()}</td>
                <td className={'col-total'} data-testid={'presell-row-' + presell.id + '-total'} onClick={navigateToPresell}>
                    {!!presell.orderStatus && <>{numberToPrice(presell.total)}</>}
                </td>
            </tr>
        </>
    );
}
